import React, { useMemo } from 'react'
import { ArticleBodyLoading } from '../../../components/article-view/article-view-loading'
import { Box } from '@mui/material'
import { SkillBiteViewer as SkillBiteViewerComponent } from '@emerald-works-nova/content-viewer'
import { useSelector } from 'react-redux'
import { skillBiteSlice } from '../../../reducers'
import { useSession } from '@emerald-works/react-auth'
import { useTenant } from '@emerald-works-nova/auth'
import { useTranslation } from '../../../hooks'
import consts from '../../../consts'

export const SkillBiteViewer = ({ isLoading, handleSaveCommitment, handleSaveCommitmentCheck, handleSaveQuiz }) => {
  const currentPage = useSelector(skillBiteSlice.selectors.selectCurrentPage)
  const { isAuthenticated } = useSession()
  const { t } = useTranslation('skill_bite')
  const tenant = useTenant()
  const isClubTenant = tenant.pk === consts.DEFAULT_CLUB_PK

  const translations = useMemo(() => {
    return {
      commitmentCheck: {
        noCommitmentMessageText: t('commitment_check_no_commitment_message'),
        lastTimeCommitmentLabelText: t('commitment_check_last_time_label'),
        commitmentCheckYesText1: t('commitment_check_yes1'),
        commitmentCheckYesText2: t('commitment_check_yes2'),
        commitmentCheckNoText1: t('commitment_check_no1'),
        commitmentCheckNoText2: t('commitment_check_no2'),
        savingCommitmentReviewText: t('commitment_saving_review_message'),
        commitmentLabelYesTitleText: t('commitment_check_label_yes_title'),
        commitmentLabelYesMessageText: t('commitment_check_label_yes_message'),
        commitmentLabelYesReviewLabelText: t('commitment_check_label_yes_review_label'),
        commitmentLabelNoTitleText: t('commitment_check_label_no_title'),
        commitmentLabelNoMessageText: t('commitment_check_label_no_message'),
        commitmentLabelNoReviewLabelText: t('commitment_check_label_no_review_label'),
        lastTimeCommitmentTitleText: t('commitment_check_last_time_commitment_title')
      },
      commitment: {
        typeHereText: t('commitment_type_here'),
        savingCommitmentText: t('commitment_saving_message')
      },
      ewQuiz: {
        statementCountText: t('quiz_statements_to_answer'),
        calculateTotalText: t('quiz_calculate_total'),
        yourScoreText: t('quiz_your_score')
      },
      transcript: {
        downloadText: t('transcript_download')
      }
    }
  }, [t])

  if (isLoading) {
    return <ArticleBodyLoading marginTop={2} />
  }

  return (
    <Box data-test='skill-bite-viewer-component-root'>
      <SkillBiteViewerComponent
        blocks={currentPage?.blocks}
        isAuthenticated={isAuthenticated}
        isClub={isClubTenant}
        translations={translations}
        onSaveCommitment={handleSaveCommitment}
        onSaveCommitmentCheck={handleSaveCommitmentCheck}
        onCalculateQuizResult={handleSaveQuiz}
        data-test='skill-bite-viewer'
      />
    </Box>
  )
}
